import marketingClient from '@/js/common/Domain/Service/marketingClient';
import { MAX_ASPECTS_COLLAPSED } from '../../config';
import type { ReviewAspect, ReviewSummaryAnalyticsContext } from '../../model/types';

export const REVIEW_SUMMARY_ACTION = {
  PAGE_VIEW: 'page_view',
  TEASER_EXPAND_CLICK: 'teaser_expand_click',
  FULL_IMPRESSION: 'full_impression',
  FULL_CRITERIA_EXPAND_CLICK: 'full_criteria_expand_click',
};

export const getReviewSummaryGoal = (action: string): string => `hotelpage_reviews_summary_${action}`;

export const getTopicsCount = (praised: ReviewAspect[], caveats: ReviewAspect[]): number =>
  praised.length + caveats.length;

export const getTopicsShownBeforeExpand = (praised: ReviewAspect[], caveats: ReviewAspect[]): number =>
  Math.min(praised.length, MAX_ASPECTS_COLLAPSED) + Math.min(caveats.length, MAX_ASPECTS_COLLAPSED);

export const buildReviewSummaryAnalyticsContext = (hotelId?: number | null): ReviewSummaryAnalyticsContext => ({
  hotel_id: hotelId ?? null,
  client_uuid: marketingClient?.getClientUuid() ?? null,
});
